import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
// import './App.css';
import { Button, Modal, FormControl, FormLabel, FormHelperText, Card, CardMedia, CardActions, IconButton } from '@material-ui/core';
// import { Formik, Field, Form } from 'formik';
import Paper from '@material-ui/core/Paper';
// import { emphasize } from '@material-ui/core/styles/colorManipulator';
import ClearIcon from '@material-ui/icons/Clear';
import { validateEmpty } from './Factory';

/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';

import Loader from '../../components/Loader';

// components

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Hero from '../../components/Hero';
import MainListicle from '../../components/MainListicle.js';
import SecondaryListicle from '../../components/SecondaryListicle';
import userInfo from 'utils/userInfo';

import { createLinkTitle } from 'utils/';
import links from 'utils/links';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    margin: '15px 0px',
  },
  cardMedia: {
    height: 108,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`,
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    outline: 'none',
    height: '80vh',
    overflowY: 'scroll'
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  },
  button: {
    backgroundColor: theme.palette.primary.main,
  },
});

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    fontFamily: `"Catamaran", "Roboto", "Helvetica", "Arial", sans-serif`,
    color: state.isSelected ? "rgba(0, 0, 0, 0.54)" : undefined,
    padding: 5,
  }),
  control: (provided, state) => ({
    ...provided,
    fontFamily: `"Catamaran", "Roboto", "Helvetica", "Arial", sans-serif`,
    borderRadius: 0,
    borderStyle: "hidden hidden solid hidden"
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

const text = {
  marginTop: "5px",
  color: "rgba(0, 0, 0, 0.54)",
  fontSize: "0.75rem",
  fontFamily: `"Catamaran", "Roboto", "Helvetica", "Arial", sans-serif`,
  lineHeight: "1em"
}

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    display: "inline-grid",
    width: "90%"
  };
}

const Eatery = props => {
  let dishes = [];
  if (props.default.eatery) {
    if (props.default.eatery.mustTryDishes) {
      if (props.default.eatery.mustTryDishes.dishes) {
        dishes = props.default.eatery.mustTryDishes.dishes.map((dish, i) => {
          return dish.name;
        })
      }
    }
  }
  return (
    <Paper style={{ padding: '15px', margin: '10px 0px' }} elevation={1}>
      <Select
        options={props.eateries}
        styles={customStyles}
        theme={theme => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: undefined,
          },
        })}
        value={
          (props.default.eatery && props.default.eatery.name)
            ? { label: props.default.eatery.name, value: props.default.eatery.name }
            : undefined
        }
        onChange={e => props.handleChange('name', props.id, e ? e.label : e)}
        placeholder="Select Eatery"
      />
      <span style={{ ...text }}>Select the eateries that are part of the list. Add them one by one</span>
      {props.default.nameErrorStatus ? (
        <span style={{ color: 'red' }}>{props.default.nameError}</span>
      ) : null}
      <br />
      {props.default.eatery ? <img src={props.default.eatery.mainImage.uri} style={{ width: "100%" }} alt="" /> : null}
      <br />
      {props.default.eatery ?
        props.default.eatery.mustTryDishes ?
          props.default.eatery.mustTryDishes.dishes ?
            <div>
              <Typography variant="subtitle1">
                Must Try Dishes
              </Typography>
              <Typography variant="subtitle2">
                {dishes.join(" • ")}
              </Typography>
            </div> : null : null : null}
      <TextField
        fullWidth
        required
        multiline
        error={props.default.descriptionErrorStatus}
        helperText={props.default.descriptionErrorStatus ? props.default.descriptionError : "Add useful tips that would enhance a visitor's experience. Or a short description on why this eatery is part of this list. "}
        label="Add Pundit Tips OR Description"
        value={props.default.description}
        onChange={e =>
          props.handleChange('description', props.id, e.target.value)
        }
        margin="dense"
        disabled={!(props.default.eatery && props.default.eatery.name)}
      />
    </Paper>
  );
};

class AddEditListicle extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    open: this.props.open,
    openPreview: this.props.openPreview,
    title: '',
    image: {
      picCredits: ''
    },
    summary: '',
    eateryList: [
      {
        name: '',
        description: '',
        images: []
      },
    ],
  };
  handleEatery(name, id, value) {
    let errors = validateEmpty(
      name + 'Error',
      value,
      name + 'ErrorStatus',
      name + ' is Required'
    );
    if (name) {
      let eateryList = [...this.state.eateryList];
      let eatery = eateryList[id];
      eatery[name] = value;
      eatery = { ...eatery, ...errors };
      if (name === "name") {
        let propEatery = this.props.eateries.find(eatery => eatery["value"] === value);
        this.props.dispatch(actions.getEatery(propEatery["id"], this.state.city)).then(() => {
          eatery["eatery"] = this.props.current;
          if (this.props.current)
            eatery.images.push(this.props.current.mainImage);
          this.forceUpdate();
        });
      }
      eateryList[id] = eatery;
      this.setState({ eateryList });
    }
  }
  addEatery() {
    let eateryList = [...this.state.eateryList];
    eateryList.push({ description: '', images: [] });
    this.setState({ eateryList });
  }
  checkErrors() {
    let isError = false;
    if (this.state.titleErrorStatus || this.validateCity()) {
      isError = true;
    }
    if (this.state.cityErrorStatus) {
      isError = true;
    }
    if (!(this.state.image.uri || this.state.url)) {
      isError = true;
    }
    this.state.eateryList.map(field =>
      (field.nameErrorStatus || field.descriptionErrorStatus)
        ? (isError = true)
        : null
    );
    return isError;
  }
  converToPostData() {
    for (let id in this.state.eateryList) {
      if (this.state.eateryList[id].name && this.state.eateryList[id].name !== '') {
        this.handleEatery('name', id, this.state.eateryList[id].name)
      }
    }
    let image = {};
    let owner = {
      id: userInfo.getUserID()
    };
    if (this.state.file) {
      this.props.dispatch(actions.postFile(this.state.file)).then(() => {
        if (this.props.fileResp) {
          if (this.props.fileResp["data"] && this.props.fileResp["data"].length > 0) {
            let data = this.props.fileResp["data"][0];
            image["uri"] = data.fileDownloadUri;
            image["name"] = data.fileName;
            let respData = { ...this.state, image, owner };
            return respData;
          }
        }
      });
    }
  }
  handleSubmit = e => {
    e.preventDefault();
    let isError = this.checkErrors();
    this.setState({ isError });
    if (!isError) {
      if (!this.state.openPreview) {
        this.setState({ openPreview: true });
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
        return;
      }
      // Create Required Data Structure to hit api
      for (let id in this.state.eateryList) {
        if (this.state.eateryList[id].name && this.state.eateryList[id].name !== '') {
          this.handleEatery('name', id, this.state.eateryList[id].name)
        }
      }
      let image = {};
      let owner = {
        id: userInfo.getUserID()
      };
      let eateryList = this.state.eateryList.map(eatery => {
        eatery["eatery"] = { id: eatery["eatery"].id };
        return eatery;
      });
      let linkTitle = this.state.title ? createLinkTitle(this.state.title) : '';
      if (this.state.file) {
        this.props.dispatch(actions.postFile(this.state.file)).then(() => {
          if (this.props.fileResp) {
            if (this.props.fileResp["data"] && this.props.fileResp["data"].length > 0) {
              let data = this.props.fileResp["data"][0];
              image["uri"] = data.fileDownloadUri;
              image["name"] = data.fileName;
              if (this.state.editMode) {
                this.props.dispatch(actions.updateData({ ...this.state, eateryList, draft: false, image, owner, linkTitle })).then(() => this.props.history.push(links.listicleWithCity(this.state.city, linkTitle)))
              } else {
                this.props.dispatch(actions.postData({ ...this.state, eateryList, draft: false, image, owner, linkTitle })).then(() => this.props.history.push(links.listicleWithCity(this.state.city, linkTitle)))
              }
            }
          }
        });
      } else {
        if (this.state.editMode) {
          this.props.dispatch(actions.updateData({ ...this.state, eateryList, draft: false, owner, linkTitle })).then(() => this.props.history.push(links.listicleWithCity(this.state.city, linkTitle)))
        } else {
          this.props.dispatch(actions.postData({ ...this.state, eateryList, draft: false, owner, linkTitle })).then(() => this.props.history.push(links.listicleWithCity(this.state.city, linkTitle)))
        }
      }
    }
  };
  handleSaveAsDraft() {
    for (let id in this.state.eateryList) {
      if (this.state.eateryList[id].name && this.state.eateryList[id].name !== '') {
        this.handleEatery('name', id, this.state.eateryList[id].name)
      }
    }
    let image = {};
    let owner = {
      id: userInfo.getUserID()
    };
    let linkTitle = this.state.title ? createLinkTitle(this.state.title) : '';
    if (this.state.file) {
      this.props.dispatch(actions.postFile(this.state.file)).then(() => {
        if (this.props.fileResp) {
          if (this.props.fileResp["data"] && this.props.fileResp["data"].length > 0) {
            let data = this.props.fileResp["data"][0];
            image["uri"] = data.fileDownloadUri;
            image["name"] = data.fileName;
            this.props.dispatch(actions.postData({ ...this.state, image, linkTitle, owner, draft: true })).then(() => this.props.history.push(links.listicleWithCity(this.state.city, linkTitle)));
          }
        }
      });
    }
  }
  uploadImage = e => {
    var file = e.target.files[0];
    if (file) {
      this.setState({ file, url: URL.createObjectURL(file) });
    }
  };
  validateTitle = () => {
    let errors = validateEmpty(
      'titleError',
      this.state.title,
      'titleErrorStatus',
      'Name is Required'
    );
    this.setState({ ...this.state, ...errors });
  };
  validateCity = () => {
    let errors = validateEmpty(
      'cityError',
      this.state.city,
      'cityErrorStatus',
      'City is Required'
    );
    this.setState({ ...this.state, ...errors });
    return errors["cityErrorStatus"];
  };
  componentWillMount() {
    let editMode = false;
    if (window.location.pathname.indexOf('edit') !== -1) {
      editMode = true;
      this.props.dispatch(actions.getListicleById(this.props.match.params.id)).then(() => {
        this.setState({ ...this.props.listicle })
      });
    }
    this.setState({ editMode });
  }
  componentDidMount() {
    this.props.dispatch(actions.getCities());
  }
  handleCity(city) {
    this.setState({ city: city ? city.value : city }, () => this.validateCity());
    this.props.dispatch(actions.getAllEateryNames(city ? city.value : city));
  }
  render() {
    const { classes, loading, eateries, cities } = this.props;
    let locationArray = this.state.eateryList.map((eaterySum, i) => {
      return {
        title: eaterySum.eatery ? eaterySum.eatery.name : "",
        lat: eaterySum.eatery ? eaterySum.eatery.location.latitude : "",
        lng: eaterySum.eatery ? eaterySum.eatery.location.longitude : ""
      }
    })
    if (loading) {
      return <Loader />;
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div className="max-w-sm w-screen p-4 sm-p-6 sm-mt-12 sm-mb-12 bg-white shadow">
            <form onSubmit={this.handleSubmit}>
              {!this.state.openPreview ? (
                <div>
                  <Typography
                    align="center"
                    color="textPrimary"
                    component="h2"
                    gutterBottom
                    variant="h4"
                  >
                    {!this.state.editMode ? 'Add Listicle' : 'Update Listicle'}
                  </Typography>
                  <TextField
                    fullWidth
                    required
                    error={this.state.titleErrorStatus}
                    // helperText={this.state.titleError}
                    value={this.state.title}
                    onChange={e =>
                      this.setState({ title: e.target.value }, () =>
                        this.validateTitle()
                      )
                    }
                    // id="outlined-required"
                    label="Name your list"
                    placeholder="12 places for the best Mysore pak in Bangalore "
                    // className={classes.textField}
                    helperText={<span>What is this list about? <span style={{ color: "#0645AD" }} onClick={() => this.setState({ open: true })}>Click Here</span> for some interesting list ideas</span>}
                    margin="dense"
                  />
                  <FormControl
                    className="w-full"
                    error={this.state.isError && !(this.state.image.uri || this.state.url)}
                    margin="normal"
                    required
                  >
                    <FormLabel className="mb-2" component="legend">
                      Featured Image
                    </FormLabel>
                    <FormHelperText className="mb-2">
                      Pick an image that captures the essence of your list.
                    </FormHelperText>
                    {(this.state.image.uri || this.state.url) && (
                      <Card>
                        <CardMedia
                          className={classes.cardMedia}
                          image={this.state.url ? this.state.url : this.state.image.uri}
                        />
                        <CardActions className="flex-col items-stretch">
                          <TextField
                            className="my-1"
                            autoComplete="name"
                            inputProps={{ maxLength: 60 }}
                            label="Photo credit"
                            name="featuredImage.photoCredit"
                            onChange={(e) => this.setState({ image: { ...this.state.image, picCredits: e.target.value } })}
                            required
                            spellCheck="false"
                            value={this.state.image.picCredits}
                          />

                          <div className="flex justify-end mt-1">
                            <IconButton
                              className="p-1"
                              aria-label="Remove"
                              onClick={() => this.setState({ file: undefined, url: undefined, image: { ...this.state.image, picCredits: '' } })}
                            >
                              <ClearIcon />
                            </IconButton>
                          </div>
                        </CardActions>
                      </Card>
                    )}
                    <div className="mt-4">
                      <input
                        accept=".jpg,.jpeg,image/jpeg"
                        className="hidden"
                        id="featured-file"
                        name="images"
                        onChange={this.uploadImage}
                        type="file"
                      />
                      <label htmlFor="featured-file">
                        <Button variant="contained" component="span">
                          Attach image
                      </Button>
                      </label>
                    </div>
                  </FormControl>
                  <br />
                  <br />
                  <FormLabel className="mb-2" component="legend">
                    City
                  </FormLabel>
                  <Select
                    aria-labelledby="city"
                    options={cities}
                    styles={customStyles}
                    theme={theme => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary: undefined,
                      },
                    })}
                    value={
                      this.state.city
                        ? { label: this.state.city, value: this.state.city }
                        : undefined
                    }
                    onChange={city => this.handleCity(city)}
                    placeholder="Select City"
                  />
                  <span style={{ ...text }}>Select the city the list covers.</span>
                  {this.state.cityErrorStatus ? (
                    <div style={{ ...text, color: 'red' }}>{this.state.cityError}</div>
                  ) : null}
                  {/* <FormHelperText>{this.state.cityErrorStatus}</FormHelperText>
            </FormControl> */}
                  <TextField
                    fullWidth
                    required
                    value={this.state.summary}
                    onChange={e => this.setState({ summary: e.target.value })}
                    id="outlined-required"
                    label="Summary"
                    placeholder="Droolicious Mysore Pak destinations in Bangalore"
                    // className={classes.textField}
                    margin="normal"
                    helperText="What's at the core of this list?"
                  />
                  {this.state.eateryList.map((eatery, id) => (
                    <Eatery
                      key={id + '_e'}
                      id={id}
                      default={eatery}
                      errors={this.state.errors}
                      handleChange={this.handleEatery}
                      eateries={eateries}
                      city={this.state.city}
                    />
                  ))}
                  <Button
                    className={classes.button}
                    variant="contained"
                    onClick={() => this.addEatery()}
                    disabled={
                      this.state.eateryList.length === 0 ||
                      ![...this.state.eateryList].pop().name
                    }
                  >
                    Add Another Eatery
            </Button>
                </div>
              ) : (
                  <div>
                    <Hero  {...{ title: this.state.title, lastUpdated: "last updated", imageUrl: !this.state.url ? this.state.image.uri : URL.createObjectURL(this.state.file), oneLiner: this.state.summary }} />
                    <SecondaryListicle {...{ data: locationArray }} />
                    {this.state.eateryList.map((eateryItem, i) => {
                      return <div key={"eateryItem" + i}>
                        <MainListicle {...{ eateryItem }} />
                        <hr />
                      </div>
                    })}
                  </div>
                )}
              <br />
              <br />
              <Button
                className={classes.button}
                type="submit"
                variant="contained"
              >
                {this.state.openPreview ? 'Submit' : 'Preview'}
              </Button>
              {this.state.openPreview ? (
                <Button
                  color={"primary"}
                  style={{ marginLeft: "10px" }}
                  onClick={() => this.setState({ openPreview: false })}
                  variant="outlined"
                >
                  Edit
            </Button>
              ) : (
                  <Button
                    color={"primary"}
                    style={{ marginLeft: "10px" }}
                    onClick={() => this.handleSaveAsDraft()}
                    variant="outlined"
                  >
                    Save as Draft
                </Button>
                )}
            </form>

            < Modal
              aria-labelledby="title"
              aria-describedby="description"
              open={this.state.open}
              onClose={() => this.setState({ open: false })}
            >
              <div style={getModalStyle()} className={classes.paper}>
                <Typography variant="body1" gutterBottom>
                  Collate your eateries into fun and funky lists based on any category you choose, like locations, cuisines, date night, or even apology dinners.
                <br />
                  <br />
                  a. Your lists could be just the names of places with a small summary of what you liked there, or tips for visitors
                <br />
                  b. It could also just be pictures of different meals that we should try.
                <br />
                  c. You could try making a list each time you explore a new city/town.
                <br />
                  d. Or even tell us all about your city/town. e. It could even be a list of restaurants that allow pets! The permutations are endless, so have fun with it!
                <br />
                </Typography>
                <Button className={classes.button} variant="contained" onClick={() => this.setState({ open: false })}>OK</Button>
              </div>
            </Modal>
          </div>
        </div >
      );
    }
  }
}

function mapStateToProps(state) {
  return selectors.getAllValues(state);
}

export default connect(mapStateToProps)(withStyles(styles)(AddEditListicle));
